import { Box, Typography } from '@material-ui/core'
import Amount from './Amount'
import { useTotalStyles } from './styles'
import { useTotalTranslation } from './translation'

const Total = ({ amount = 0, installments = 0, registrationFee = 0 }) => {
  const styles = useTotalStyles()
  const translation = useTotalTranslation()
  
  // Calcular o total: (parcelas × valor) + taxa de matrícula
  const calculateTotal = () => {
    // Garantir que todos os valores sejam números
    const numAmount = parseFloat(amount) || 0
    const numInstallments = parseInt(installments) || 0
    const numRegistrationFee = parseFloat(registrationFee) || 0
    
    let total = numAmount
    
    // Se há parcelas maiores que 1, multiplica o valor pelas parcelas
    if (numInstallments > 1) {
      total = numAmount * numInstallments
    }
    
    // Adiciona a taxa de matrícula se existir
    if (numRegistrationFee > 0) {
      total += numRegistrationFee
    }
    
    return total
  }
  
  const totalAmount = calculateTotal()
  
  return (
    <Box className={styles.container}>
      <Typography className={styles.label}>{translation.label}</Typography>
      <Amount amount={totalAmount} className={styles.amount} />
    </Box>
  )
}

export default Total